import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/// COMPONENTES DE IDIOMAS
//import { LangConfigComponent } from './i18n/configuracion/configuracion.component';

@NgModule({
  declarations: [
    //LangConfigComponent
  ],
  imports: [
    TranslateModule
  ]
})
export class IdiomasModule { }
